// Internal modules
// @ts-expect-error untyped-import
import { createCardTypesChangeHandlerForField } from '../utils';
import {
  blurHandler as genericBlurHandler,
  changeHandler as genericChangeHandler,
  // @ts-expect-error untyped-import
} from '../../../Form/handlers';
import { conditionallyClearCardConversion } from '../CurrencyConversion';
import { conditionallyFetchConversionData } from '@/lib/graphql/operations/currencyConversion';
import {
  conditionallyFetchCardMeta,
  conditionallyFetchInstallments,
} from './utils';

/**
 * ON ALLOWED CARD TYPES CHANGE
 * After the allowed card types have been retrieved we need to revalidate
 * the input since the validation includes checks for disallowed card types
 *
 * ON CARD TYPE SELECTOR CHANGE
 * After the CardTypeSelector changes we need to validate the card field
 * Test case: enter card number first and later change CardTypeSelector dropdown
 */
const cardTypesChangeHandler =
  createCardTypesChangeHandlerForField('cardNumber');

const blurHandler = (e: React.MouseEvent<HTMLInputElement>): void => {
  e.persist();
  genericBlurHandler(e);

  // For a blur event e.relatedTarget will be the element that is
  // going to be focused once the current field that is being blurred
  // is no longer the active element
  const nextFocusedEl = e.relatedTarget as HTMLInputElement;
  conditionallyFetchConversionData(nextFocusedEl);
};

const changeHandler = (
  ...args: [React.ChangeEvent<HTMLInputElement>, string]
): void => {
  // If the card number changes and we have conversion data that we are
  // displaying, we need to clear it since the conversion data is on a per
  // card basis. Updated data will be fetched on blur of the card number field.
  conditionallyClearCardConversion();

  // Get the card meta which is needed for use cases such as
  // multi-branded CUP cards, combo cards, cobrand cards, etc.
  conditionallyFetchCardMeta(...args);

  // The generic change handler will update the store with the new value
  genericChangeHandler(...args);

  // Get the installment options for applicable transactions
  conditionallyFetchInstallments();
};

export { blurHandler, cardTypesChangeHandler, changeHandler };
